module.exports = __webpack_public_path__ + "static/media/Icons_history.d2614783.svg";